module.exports = __webpack_public_path__ + "static/media/placeholder.6e9b224a.svg";